import { logger } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';

export { wrapTrackRequestMetrics } from '../../../server/utils/requestMetrics';

/**
 * Log errors for client-side requests
 * @param {string} message
 * @param {{error: Error} & Record<string, any>} error
 */
export const logError = (message, { error, ...data }) => {
    const { url, userId, experience, pathParameters } = getContext();
    logger.error(message, {
        ...data,
        details: {
            url,
            userId,
            experience,
            pathParameters,
        },
        error,
    });
};
